import MuiBox from '@mui/material/Box';
import MuiListItemButton from '@mui/material/ListItemButton';
import MuiListItemIcon from '@mui/material/ListItemIcon';
import type { MouseEvent, ReactElement } from 'react';
import { isInternalPath } from '../../lib/isInternalPath';
import type { NavDrawerItem } from './NavDrawer';
import { iconSx, labelSx, rowSx } from './navDrawerStyles';
import { Tooltip } from './Tooltip';

interface NavDrawerLinkProps {
  item: NavDrawerItem;
  collapsed: boolean;
  onNavigate: (href: `/${string}`) => void;
}

// A real link, so «open in new tab» and modified clicks keep working.
export function NavDrawerLink({ item, collapsed, onNavigate }: NavDrawerLinkProps): ReactElement {
  const follow = (event: MouseEvent<HTMLAnchorElement>): void => {
    // Modified and middle clicks belong to the browser: new tab, new window, download.
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    onNavigate(item.href);
  };
  // A path that would leave the panel never reaches the DOM: the entry stays, dead, like Button's.
  const safe = isInternalPath(item.href);
  return (
    <Tooltip title={collapsed ? item.label : ''}>
      <MuiListItemButton
        component="a"
        sx={rowSx}
        {...(safe ? { href: item.href, onClick: follow } : { role: 'link' })}
        disabled={!safe}
        aria-label={item.label}
        {...(item.current ? { 'aria-current': 'page' as const } : {})}
      >
        <MuiListItemIcon sx={iconSx}>{item.icon}</MuiListItemIcon>
        {collapsed ? null : (
          <MuiBox component="span" sx={labelSx}>
            {item.label}
          </MuiBox>
        )}
      </MuiListItemButton>
    </Tooltip>
  );
}
